import { render, staticRenderFns } from "./ProfileMyProfile.vue?vue&type=template&id=0b366024&scoped=true&"
import script from "./ProfileMyProfile.vue?vue&type=script&lang=ts&"
export * from "./ProfileMyProfile.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileMyProfile.vue?vue&type=style&index=0&id=0b366024&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b366024",
  null
  
)

export default component.exports